import styled from 'styled-components';

export const AddressStateBlock = styled.div`
  margin-top: ${({ marginTop }) => `${marginTop}px`};
  margin-bottom: ${({ marginBottom }) => `${marginBottom}px`};
`;
